import Component from '../core/Component'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export default class ProfileCards extends Component {
    constructor(element) {
        super(element)

        this.enquireHandler = {
            match: this.attach,
            unmatch: this.detach
        }

        this.flickity = null
    }

    prepare() {
        enquire.register(queries.largeMax, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.largeMax, this.enquireHandler)
    }


    attach = () => {
        this.flickity = new Flickity(this.element, {
            cellSelector: '[data-ref="card"]',
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
            resize: true
        })
    }

    detach = () => {
        this.flickity?.destroy()
    }

}
